import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vistoria-veicular',
  templateUrl: './vistoria-veicular.component.html',
  styleUrls: ['./vistoria-veicular.component.scss']
})
export class VistoriaVeicularComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
